<template>


    <form-with-base-message ref="form" :base-errors="getErrorForField('base')"
                            class="container_form"
                            translations-scope="Login"
                            :success-message="successMessage">

        <v-container fluid>
            <v-layout row wrap>

                <v-flex xs12>
                    <v-text-field
                            autocomplete="new-password"
                            ref="username"
                            v-model="username"
                            placeholder="Username"
                            background-color="primary"
                            color="seconary"
                            solo
                            :error-messages="getErrorForField('username')"
                            name="username"
                    ></v-text-field>
                </v-flex>

                <v-flex xs12>
                    <v-text-field
                            autocomplete="new-password"
                            ref="password"
                            :append-icon="show_password ? 'mdi-eye-off' : 'mdi-eye'"
                            name="password"
                            v-model="password"
                            placeholder="Password"
                            background-color="primary"
                            solo
                            :error-messages="getErrorForField('password')"
                            color="secondary"
                            :type="show_password ? 'text' : 'password'"
                            @click:append="toggle_password">


                    </v-text-field>
                </v-flex>

                <v-flex xs12>
                    <v-btn block class="eco-button"
                           color="button-light"
                           large
                           type="submit"
                           @click.prevent="executeLogin()">
                        {{$vuetify.t('$vuetify.Login.enter') | uppercase
                        }}

                    </v-btn>

                  <SharedLoginButtons></SharedLoginButtons>

                </v-flex>

            </v-layout>
        </v-container>
    </form-with-base-message>


</template>


<script>

    import {onLogin} from "../vue-apollo"
    import {ApolloProvider} from "../apollo-provider"
    import FormWithBaseMessage from "../components/FormWithBaseMessage"
    import SharedLoginButtons from "../components/SharedLoginButtons";
    import {getAppBaseUrl} from "../helpers/location"


    export default {
        name: "Login",
        data: function () {

            return {
                errors: {},
                username: "",
                show_password: false,
                password: "",
                successMessage: {}

            }
        },
        methods: {
            toggle_password() {
                this.show_password = !this.show_password
            },
            executeLogin() {

                this.errors = {}

                const LOGIN_MUTATION = require("../graphql/mutations/login.gql")
                this.$apollo.mutate({
                    client: "clientPublic",
                    // Query
                    mutation: LOGIN_MUTATION,
                    // Parameters
                    variables: {
                        username: this.username,
                        password: this.password,
                        webAppConfirmationUri: this.getWebAppConfirmationUri()


                    },

                }).then((result) => {

                    result = result.data.login

                    if (result._response.result) {
                        this.$vuetify.lang.current = result.result.user.language
                        this.successMessage = {
                            title: this.$vuetify.t("$vuetify.Login.loginSuccesfullyTitle"),
                            text: this.$vuetify.t("$vuetify.Login.loginSuccesfully")
                        }

                        this.$refs.form.resetForm()
                        onLogin(ApolloProvider.clients.clientPublic, result.result.jwt)
                            .then(() => {
                            setTimeout(()=>{
                                this.$router.push({name: "picks-up"})
                            },3200)
                        })
                    } else {

                        this.errors = this.collectErrors(result._response.errors)
                    }


                }).catch((error) => {
                    console.log(error)

                    //TODO implementare default error catcher
                    // Error
                    //console.error(error)

                })
            },
            getWebAppConfirmationUri() {
                const resetRoute = this.$router.options.routes.filter((r) => r.name === "user-confirmation")[0]
                let routePath = ""
                if (resetRoute) {
                    routePath = resetRoute.path
                }
                return `${getAppBaseUrl()}${routePath}`

            },
            collectErrors(errors) {
                let toReturn = {}
                errors.forEach((error, index) => {
                    const fieldRef = error.field
                    const validations_keys = error.validations.map((v) => v.errorKey)

                    if (!toReturn[fieldRef]) {
                        toReturn[fieldRef] = []
                    }
                    validations_keys.forEach((ek) => {
                        const er_label = this.$vuetify.t(`$vuetify.Login.errors.${ek}`)
                        toReturn[fieldRef].push(er_label)

                    })

                })
                return toReturn
            },
            getErrorForField(fieldName) {
                if (this.errors[fieldName]) {
                    return this.errors[fieldName]
                } else {
                    return []
                }
            }
        },
        components: {
            FormWithBaseMessage,
            SharedLoginButtons
        }

    }
</script>


<style scoped lang="scss">

    .container_form {
        height: 350px;
        margin: auto 30px;

    }

</style>